import { atom } from "jotai";

export const SettingsStepState = {
  isLoadingAtom: atom<boolean>(false),
};
